export enum LinkTarget {
  NewWindow = '_blank',
  CurrentWindow = '_self'
}
